export default __webpack_public_path__ + "static/wowawards-3eb1e705296c6bbdbb45c2df720202f5.png";